export default [{
  key: 'isOdd',
  label: 'est impaire'
}, {
  key: 'isEven',
  label: 'est paire'
}];
